import React, { Component } from 'react';
import { bool, func, number, object, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { actions as jobPricingStatusActions } from '../Common/JobPricingStatusState';
import { actions as jobMatchingActions } from '../Common/JobState';
import { actions as organizationStatisticsActions } from '../Common/OrganizationStatisticsState';
import { actions as surveyActivityActions } from '../Common/SurveyActivityState';
import MarketPricingDisplay from './MarketPricingDisplay';

class MarketPricing extends Component {
  static propTypes = {
    dispatch: func,
    history: object,
    jobPricingStatus: shape({
      data: shape({
        neither: number,
        priced: number,
        slotted: number
      }),
      error: string,
      loading: bool
    }),
    location: object,
    match: object,
    priceJobClick: func,
    adHocPricingClick: func,
    pricingYear: number,
    launchDarklyFeatureFlags: object,
    permissions: object
  };

  constructor(props) {
    super(props);
    this.chartInteraction = this.chartInteraction.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    jobPricingStatusActions.getJobPricingStatus(dispatch);
    organizationStatisticsActions.getOrganizationStatistics(dispatch);
    surveyActivityActions.getSurveyActivity(dispatch);
    jobMatchingActions.getJobMatches(dispatch);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { dispatch, surveyYear } = this.props;
    if (this.props === nextProps) return;
    if (surveyYear !== nextProps.surveyYear) jobPricingStatusActions.getJobPricingStatus(dispatch);
  }

  shouldComponentUpdate(nextProps) {
    return this.props !== nextProps;
  }

  chartInteraction(pricingName) {
    const { history } = this.props;
    const pricingUrl = `/iframe/merit/pricing2/price`;
    history.push({ pathname: pricingUrl, search: `?initial_priced_slotted=${pricingName}` });
  }

  render() {
    const {
      jobPricingStatus,
      priceJobClick,
      adHocPricingClick,
      surveyYear,
      launchDarklyFeatureFlags,
      permissions
    } = this.props;
    const { data, error, loading } = jobPricingStatus;

    return (
      <MarketPricingDisplay
        chartInteraction={this.chartInteraction}
        error={error}
        loading={loading}
        neither={data.neither}
        priced={data.priced}
        priceJobClick={priceJobClick}
        adHocPricingClick={adHocPricingClick}
        pricingYear={surveyYear}
        slotted={data.slotted}
        launchDarklyFeatureFlags={launchDarklyFeatureFlags}
        permissions={permissions}
      />
    );
  }
}

const mapStateToProps = ({ landingDashboard, session }) => ({
  jobPricingStatus: landingDashboard.JobPricingStatus,
  surveyYear: landingDashboard.OrganizationStatistics.data.statistics.surveyYear,
  permissions: session.user.rights
});

export default connect(mapStateToProps)(withRouter(MarketPricing));
